import React from 'react'
import guy from '../../images/image (35).png'
import { useLanguage } from "../../Providers/LanguageContext";
const AgricultureBanner = ({ construction, agriculture, ecommerce,
    healthcare,education,account,energy,manufacture,government 
    ,hospital,estate,legal,retailer,nonProfit,oil,technology,transport}) => {
    const { language, currentLanguage } = useLanguage();
    return (
        <>
            <div className="general_user_banner_Wrapper" style={{
                // backgroundColor: '#fff',
                paddingBottom:'20px'
            }}>

                <div className="container-fluid general_user_banner_content_wrapper" style={{
                    paddingTop: '70px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div className="left_banner_content" style={{
                        marginTop: '-70px'
                    }}>
                        {agriculture && <h1>{language.agriculture}</h1>}
                        {construction && <h1>{language.construction}</h1>}
                        {ecommerce && <h1>{language.electronic_commerce}</h1>}
                        {healthcare && <h1>{language.health_care}</h1>}
                        {education && <h1>{language.education}</h1>}
                        {account  && <h1>  {language.accountant_accounting_firm}</h1>}
                        {energy && <h1>{language.energy}</h1>}
                        {manufacture && <h1>{language.manufacturing}</h1>}
                        {government && <h1>{language.government}</h1>}
                        {hospital && <h1>{language.hospitality}</h1>}
                        {estate && <h1>{language.real_estate}</h1>}
                        {legal && <h1>{language.legal}</h1>}
                        {retailer && <h1>{language.retailers}</h1>}
                        {nonProfit && <h1 style={{
                            textTransform:'capitalize'
                        }}>{language.non_profit_organization}</h1>}
                        {oil && <h1>{language.oil_and_gas}</h1>}
                        {technology && <h1>{language.technology}</h1>}
                        {transport && <h1>{language.transportation}</h1>}




                        <h6 style={{

                            fontSize: '17px',
                            lineHeight: '25px'
                        }}>Fisibility's comprehensive data audit
                            capabilities help banks monitor the ongoing financial
                            performance of their loan portfolios, reducing the risk
                            of non-performing loans and loan compliance issues.</h6>
                    </div>
                    <div className="right_banner_content">
                        <img src={guy} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AgricultureBanner